enum Action {
  ACTIVATE = 'ACTIVATE',
  CONFIRM = 'CONFIRM',
  CREATE = 'CREATE',
  DELETE = 'DELETE'
}

export default Action
